module.exports = __webpack_public_path__ + "06721e6cc9b66866c6482d2bf3b4b16c.js";